import log2 from "../js/log2-lite";
import tracker from "./tracker";
import { isEcommerceEvent } from "./tracker/events";
const { isShellTab } = require("./shellLinks");

const log = log2("SUPSIS_SDK");
let triggersDisabledBySdk = false;
export const areTriggersDisabled = () => triggersDisabledBySdk;
const isLoaded = () => {
    return !!(window.supsis && window.supsis.i && window.supsis.i.connected);
};
export const onLoaded = () =>
    isLoaded()
        ? Promise.resolve(window.supsis.i)
        : new Promise((resolve) => {
              // "supsis-loaded" bir kez atilir; gec baglanan dinleyici kacirabilir, bu yuzden durum da yoklanir.
              // Zaman asiminda ASLA cozulmez: baglanmamis bir ls, iframe'siz gecmeye calisan tum eski
              // cagiranlari (SET_USER_DATA, LOGIN, preJobs vb.) kirar; sadece yoklama durdurulur.
              let done = false;
              const finish = () => { if (done) return; done = true; clearInterval(timer); resolve(window.supsis.i); };
              window.addEventListener("supsis-loaded", finish, false);
              let tries = 0;
              const timer = setInterval(() => { if (isLoaded()) finish(); else if (++tries > 150) clearInterval(timer); }, 200);
          });

export const onMinimized = () =>
    new Promise((resolve) => {
        window.addEventListener(
            "supsis-minimized",
            function (e) {
                resolve(window.supsis.i);
            },
            false
        );
    });

export const onTabVisible = () =>
    document.visibilityState === "visible"
        ? Promise.resolve(true)
        : new Promise((resolve) => {
              document.addEventListener("visibilitychange", visibilityHandler);

              function visibilityHandler() {
                  if (document.visibilityState === "visible") {
                      document.removeEventListener("visibilitychange", visibilityHandler);
                      resolve(true);
                  }
              }
          });

const COMMANDS = {
    MINIMIZE: "minimize",
    CHANGE_DEPARTMENT: "department",
    MAXIMIZE: "open",
    SET_USER_DATA: "setUserData",
    READY_EVENT: "ready",
    MINIMIZE_EVENT: "onMinimized",
    LOGIN: "login",
    DESTROY: "destroy",
    ASK: "ask",
    SET_CHATBOT_START_BLOCK_ID: "setChatbotStartBlockId",
    CLOSE_CHAT: "closeChat",
    SET_CONTACT_PROPERTY: "setContactProperty",
    HIDE: "hide",
    CLEAR_CACHE: "clearCache",
    SET_VIP_CUSTOMER: "setVipCustomer",
    SET_WINDOW_SIZE: "setWindowSize",
    SET_TRIGGER_DATA: "setTriggerData",
    NAVIGATE: "navigate",
    DISABLE_TRIGGERS: "disableTriggers",
    // Host sayfasindan ziyaretci adina mesaj (ör. Supsis paneli: SupHi'nin destek devri). Sohbet bagliysa mesaj olarak,
    // degilse ilk mesajla giris (autoLogin) olarak gider.
    SEND_MESSAGE: "sendMessage",
    // Web analytics komutlari; socket gerektirmez, tracker uzerinden calisir
    TRACK: "track",
    IDENTIFY: "identify",
    ALIAS: "alias",
    GROUP: "group",
    RESET: "reset",
    CONSENT: "consent",
    ECOMMERCE: "ecommerce",
    ANALYTICS: "analytics",
};

/**
 * Web analytics komutlari tek yerde toplanir.
 * @returns {boolean} komut burada islendiyse true
 */
const handleAnalyticsCommand = (cmd, payload, extra) => {
    if (cmd === COMMANDS.TRACK) {
        // supsis("track", "add_to_cart", { product_id: "1" })
        if (typeof payload === "string") {
            tracker.track(payload, extra);
        } else if (payload && payload.name) {
            tracker.track(payload.name, payload.props || payload.properties);
        } else {
            log.error("track command requires an event name");
        }
        return true;
    }
    if (cmd === COMMANDS.ECOMMERCE) {
        const name = typeof payload === "string" ? payload : payload && payload.name;
        if (!isEcommerceEvent(name)) {
            log.error("unknown ecommerce event", name);
            return true;
        }
        tracker.track(name, typeof payload === "string" ? extra : payload.props || payload.properties);
        return true;
    }
    if (cmd === COMMANDS.IDENTIFY) {
        tracker.identify(payload);
        return true;
    }
    if (cmd === COMMANDS.ALIAS) {
        tracker.alias(payload);
        return true;
    }
    if (cmd === COMMANDS.GROUP) {
        tracker.group(payload);
        return true;
    }
    if (cmd === COMMANDS.RESET) {
        tracker.reset();
        return true;
    }
    if (cmd === COMMANDS.CONSENT) {
        tracker.consent(payload);
        return true;
    }
    if (cmd === COMMANDS.ANALYTICS) {
        // Sayfa bazli override: ayarda kapali olan collector buradan acilamaz
        tracker.overrideConfig(payload);
        return true;
    }
    return false;
};
// Widget nesnesine dogrudan dokunan komutlar; tracker.js (yalnizca tracking) modunda widget yoktur
// sendMessage icin ust sinir (karakter)
const SEND_MESSAGE_MAX_CHARS = 4000;
const WIDGET_DIRECT_COMMANDS = [
    COMMANDS.MINIMIZE,
    COMMANDS.MAXIMIZE,
    "maximize",
    COMMANDS.ASK,
    COMMANDS.CLOSE_CHAT,
    COMMANDS.SET_VIP_CUSTOMER,
    COMMANDS.SET_WINDOW_SIZE,
];
const handleCommand = (cmd, payload, extra) => {
    const ls = window.supsis.i;
    log("handleCommand", { cmd, payload, ls });
    // Analytics komutlari widget'in yuklenmesini beklemez
    if (handleAnalyticsCommand(cmd, payload, extra)) return;
    if (!ls && WIDGET_DIRECT_COMMANDS.indexOf(cmd) !== -1) {
        log.warn("web chat widget is not loaded; command ignored", cmd);
        return;
    }
    if (cmd === COMMANDS.MINIMIZE) {
        ls.minimizeButton.click();
    } else if (cmd === COMMANDS.MAXIMIZE || cmd === "maximize") {
        document.body.classList.remove("ls-hide");
        ls.openOptions = payload;
        // Menu burada gizlenmiyor: mobilde secenek tasimayan acilis baloncuk dokunusu
        // gibi kanal menusunu acar; sohbet acilirken menuyu acilis yolu kendisi kaldirir
        // ve onceki halini saklar (burada gizlenince kucultmede geri gelmiyordu).
        ls.openButton.click();
    } else if (cmd === COMMANDS.ASK) {
        ls.askDialog(payload);
    } else if (cmd === COMMANDS.SET_USER_DATA) {
        // Kullanici bilgisi web analytics tarafinda da kimlik olarak islenir
        tracker.identify(payload);
        onLoaded().then((ls) => {
            log("SDK:SET_USER_DATA sending to iframe", payload);
            ls.iframe.contentWindow.postMessage(
                {
                    command: "set-user-data",
                    payload,
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.LOGIN) {
        onLoaded().then((ls) => {
            log("SDK:LOGIN sending to iframe", payload);
            ls.iframe.contentWindow.postMessage(
                {
                    command: "auto-login",
                    payload,
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.CHANGE_DEPARTMENT) {
        onLoaded().then((ls) => {
            log("SDK:CHANGE_DEPARTMENT sending to iframe", payload);
            for (let i = 0; i < 100; i++) {}
            ls.iframe.contentWindow.postMessage(
                {
                    command: "set-department",
                    payload,
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.SET_CHATBOT_START_BLOCK_ID) {
        onLoaded().then((ls) => {
            log("SDK:SET_CHATBOT_START_BLOCK_ID sending to iframe", payload);
            ls.iframe.contentWindow.postMessage(
                {
                    command: "set-chatbot-start-block-id",
                    payload,
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.SEND_MESSAGE) {
        // Bos metin yok sayilir; uzunluk ziyaretci mesaji sinirinda kesilir (iframe tarafinda da ayni kontrol var)
        const raw = typeof payload === "string" ? payload : payload && payload.text;
        const text = String(raw == null ? "" : raw).trim().slice(0, SEND_MESSAGE_MAX_CHARS);
        if (!text) {
            log.warn("SDK:SEND_MESSAGE empty text ignored");
            return;
        }
        onLoaded().then((ls) => {
            log("SDK:SEND_MESSAGE sending to iframe", { length: text.length });
            ls.iframe.contentWindow.postMessage(
                {
                    command: "send-message",
                    payload: { text },
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.READY_EVENT) {
        const cb = payload;
        onLoaded().then(() => {
            cb(window.supsis);
        });
    } else if (cmd === COMMANDS.CLOSE_CHAT) {
        ls.iframe.contentWindow.postMessage(
            {
                command: "close-chat",
                payload,
            },
            "*"
        );
    } else if (cmd === COMMANDS.MINIMIZE_EVENT) {
        const cb = payload;
        onMinimized().then(() => {
            cb(window.supsis);
        });
    } else if (cmd === COMMANDS.DESTROY) {
        let selectors = [
            "#previewScript",
            "#ls-openButton",
            "#ls-trigger",
            "#ls-container",
            "#supsis-actions",
            "#ls-fab",
            "#supsis-trigger-card",
            "#ls-trigger-dialog",
            "#ls-trigger-dialog-modal",
            "#ls-trigger-dialog-modal-mask",
        ];
        selectors.forEach((selector) => {
            let elements = document.querySelectorAll(selector);
            elements.forEach((element) => element.parentNode.removeChild(element));
        });
        window.supsis = undefined;
        window.supsisLoadingStarted = undefined;
    } else if (cmd === COMMANDS.SET_CONTACT_PROPERTY) {
        onLoaded().then((ls) => {
            log("SDK:SET_CONTACT_PROPERTY sending to iframe", payload);
            ls.iframe.contentWindow.postMessage(
                {
                    command: "set-contact-property",
                    payload,
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.HIDE) {
        document.body.classList.add("ls-hide");
    } else if (cmd === COMMANDS.CLEAR_CACHE) {
        onLoaded().then((ls) => {
            log("SDK:LOGIN sending to iframe", payload);
            ls.iframe.contentWindow.postMessage(
                {
                    command: "clear-cache",
                    payload: {},
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.SET_VIP_CUSTOMER) {
        ls.iframe.contentWindow.postMessage(
            {
                command: "set-vip-customer",
                payload: {
                    isVipCustomer: payload,
                },
            },
            "*"
        );
    } else if (cmd === COMMANDS.SET_WINDOW_SIZE) {
        log("SDK:SET_WINDOW_SIZE", payload);
        const mode = payload;
        if (mode === "videocall") {
            window.supsis.i.container.classList.add("videocall");
        } else if (mode === "large") {
            window.supsis.i.container.classList.add("supsis-large-mode");
        } else {
            window.supsis.i.container.classList.remove("videocall");
            window.supsis.i.container.classList.remove("supsis-large-mode");
        }
    } else if (cmd === COMMANDS.SET_TRIGGER_DATA) {
        onLoaded().then((ls) => {
            log("SDK:SET_TRIGGER_DATA sending to iframe", payload);
            ls.iframe.contentWindow.postMessage(
                {
                    command: "set-trigger-data",
                    payload,
                },
                "*"
            );
        });
    } else if (cmd === COMMANDS.NAVIGATE) {
        // Iframe soguk baslangicta MAXIMIZE'in kendi tikla-yukle akisiyla kuruluyor; ancak openButton'a
        // tiklama dinleyicisini baglayan supsis-actions.js soguk baslangicta henuz yuklenmemis olabilir,
        // o durumda ilk tik bosa gider. liveTraffic/donen ziyaretcide iframe zaten var ama acik degil,
        // bu yuzden "olusma" degil "acilma" (ls-opened / iframeLoading) yoklanir
        let tries = 0;
        const retryTimer = setInterval(() => {
            if (!window.supsis || !window.supsis.i) {
                clearInterval(retryTimer);
                return;
            }
            const opening = document.body.classList.contains("ls-opened") || window.supsis.i.iframeLoading;
            if (opening || ++tries > 30) {
                clearInterval(retryTimer);
                return;
            }
            handleCommand(COMMANDS.MAXIMIZE, {});
        }, 300);
        handleCommand(COMMANDS.MAXIMIZE, {});
        onLoaded().then((ls) => {
            // Bu koruma sadece iframe yok edilme yarisi icin; normal akista ls her zaman gelir
            if (!ls || !ls.iframe) return;
            log("SDK:NAVIGATE", payload);
            ls.iframe.contentWindow.postMessage({ command: "shell-navigate", payload }, "*");
        });
    } else if (cmd === COMMANDS.DISABLE_TRIGGERS) {
        triggersDisabledBySdk = true;
        const dismissHostTrigger = () => {
            const ids = [
                "supsis-trigger-card",
                "ls-trigger",
                "ls-trigger-dialog",
                "ls-trigger-dialog-modal",
                "ls-trigger-dialog-modal-mask",
            ];
            ids.forEach((id) => {
                const el = document.getElementById(id);
                if (el && el.parentNode) el.parentNode.removeChild(el);
            });
        };
        dismissHostTrigger();
        onLoaded().then((ls) => {
            ls.triggersDisabled = true;
            dismissHostTrigger();
            if (ls.iframe && ls.iframe.contentWindow) {
                ls.iframe.contentWindow.postMessage(
                    {
                        command: "disable-triggers",
                        payload: {},
                    },
                    "*"
                );
            }
        });
    } else {
        log.error("unhandled message received", cmd);
    }
};

let preJobs = [];

const isInitialized = () => {
    return typeof window.supsis === "function" && window.supsis.loaded;
};
export const isInitializedBefore = isInitialized();
const SDK = function (cmd, payload, extra) {
    handleCommand(cmd, payload, extra);
};

const initializeSDK = () => {
    if (!isInitializedBefore) {
        SDK.minimize = () => {
            handleCommand(COMMANDS.MINIMIZE, {});
        };
        // Kabuk sekmesine gecmek icin: supsis.open("help")
        SDK.open = (payload) => {
            if (typeof payload === "string" && isShellTab(payload)) return handleCommand(COMMANDS.NAVIGATE, { tab: payload });
            handleCommand(COMMANDS.MAXIMIZE, payload);
            document.body.classList.remove("ls-hide");
        };
        // Yardim merkezinde bir makaleyi acmak icin: supsis.openArticle("kargo-sureleri")
        SDK.openArticle = (article) => handleCommand(COMMANDS.NAVIGATE, { tab: "help", article: String(article || "") });
        // Yardim merkezinde arama yapmak icin: supsis.search("iade kosullari")
        SDK.search = (query) => handleCommand(COMMANDS.NAVIGATE, { tab: "help", query: String(query || "") });
        SDK.hide = () => {
            handleCommand(COMMANDS.HIDE, {});
        };
        SDK.ask = (payload) => {
            handleCommand(COMMANDS.ASK, payload);
        };
        SDK.login = (payload) => {
            handleCommand(COMMANDS.LOGIN, payload);
        };
        // Ziyaretci adina mesaj gonderir: supsis.sendMessage("Merhaba"). Panel bu fonksiyonun varligina bakarak
        // yeni loader'i tanir (typeof window.supsis.sendMessage === "function").
        SDK.sendMessage = (text) => {
            handleCommand(COMMANDS.SEND_MESSAGE, { text });
        };
        SDK.ready = (cb) => {
            handleCommand(COMMANDS.READY_EVENT, cb);
        };
        SDK.setUserData = (userData) => {
            handleCommand(COMMANDS.SET_USER_DATA, userData);
        };
        SDK.setContactProperty = (data) => {
            handleCommand(COMMANDS.SET_CONTACT_PROPERTY, data);
        };
        SDK.changeDepartment = (department) => {
            handleCommand(COMMANDS.CHANGE_DEPARTMENT, department);
        };
        SDK.clearCache = () => {
            handleCommand(COMMANDS.CLEAR_CACHE, {});
        };
        SDK.closeChat = () => {
            handleCommand(COMMANDS.CLOSE_CHAT, {});
        };
        SDK.setVipCustomer = (vipCustomer) => {
            handleCommand(COMMANDS.SET_VIP_CUSTOMER, vipCustomer);
        };
        SDK.setWindowSize = (mode) => {
            handleCommand(COMMANDS.SET_WINDOW_SIZE, mode);
        };
        SDK.setTriggerData = (data) => {
            handleCommand(COMMANDS.SET_TRIGGER_DATA, data);
        };
        SDK.disableTriggers = () => {
            handleCommand(COMMANDS.DISABLE_TRIGGERS, {});
        };
        SDK.track = (name, props) => {
            handleCommand(COMMANDS.TRACK, name, props);
        };
        SDK.ecommerce = (name, props) => {
            handleCommand(COMMANDS.ECOMMERCE, name, props);
        };
        SDK.identify = (traits) => {
            handleCommand(COMMANDS.IDENTIFY, traits);
        };
        SDK.alias = (id) => {
            handleCommand(COMMANDS.ALIAS, id);
        };
        SDK.group = (payload) => {
            handleCommand(COMMANDS.GROUP, payload);
        };
        SDK.reset = () => {
            handleCommand(COMMANDS.RESET, {});
        };
        SDK.consent = (payload) => {
            handleCommand(COMMANDS.CONSENT, payload);
        };
        SDK.analytics = (payload) => {
            handleCommand(COMMANDS.ANALYTICS, payload);
        };
        SDK.maximize = SDK.open;
        return true;
    } else {
        return false;
    }
};

/**
 * Analytics komutlari widget yuklenmesini beklemez; kuyruktan hemen calistirilir.
 * Geri kalan komutlar iframe baglanmasini bekler.
 */
const drainAnalyticsJobs = () => {
    const pending = [];
    preJobs.forEach((job) => {
        if (!handleAnalyticsCommand(job[0], job[1], job[2])) pending.push(job);
    });
    preJobs = pending;
};

onLoaded().then((ls) => {
    log.info("pre defined commands running", preJobs);
    preJobs.forEach((x) => handleCommand(x[0], x[1], x[2]));
});

(() => {
    if (window.supsisLoadingStarted) {
        log.error("supsis initialized before");
        return;
    }
    if (!initializeSDK()) {
        log.error("supsis sdk initialized before");
        return;
    }
    if (typeof window.supsis === "function" && Array.isArray(window.supsis.q)) {
        preJobs = window.supsis.q;
        SDK.q = window.supsis.q;
        SDK.l = window.supsis.l;
        if (window.supsis.i) SDK.i = window.supsis.i;
        SDK.loaded = true;
    }

    window.supsis = SDK;
    // Tracker init'i site ayarlari geldikten sonra olur; o ana kadar kuyrukta bekleyen
    // analytics komutlari tracker hazir olunca calisir.
    window.addEventListener("supsis-analytics-ready", drainAnalyticsJobs, false);
})();



//////////////////
// WEBPACK FOOTER
// ./static/src/sdk.js
// module id = Y9DH
// module chunks = 1 2